import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import App from '@/App'
import { queryClient } from '@/lib/queryClient'
import { theme } from '@/theme'

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root was not found.')

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/*
        `noSsr` avoids the extra render pass MUI performs to prevent hydration
        mismatches. This is a client-only SPA, so the flag removes the light-mode
        flicker when a user who pinned dark mode refreshes the page.
      */}
      <ThemeProvider theme={theme} noSsr>
        {/* Date inputs across the app share one adapter (MUI X DatePicker). */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <CssBaseline />
          <App />
        </LocalizationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
)
